import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
export type Option = {
  value: number,
  label: string
}

@Component({
  selector: 'icos-pagination-size',
  template: `
    <icos-select [model]="model" (modelChange)="modelChange.emit($event)"
      popper-class="is-arrow-fixed">
      <icos-option *ngFor="let item of options"
        [label]="item.label"
        [value]="item.value"></icos-option>
    </icos-select>
  `,
})
export class IcosPaginationSize implements OnInit {

  @Input() model: number
  @Input() sizes: number[]
  @Output() modelChange: EventEmitter<number> = new EventEmitter<number>()

  options: Option[]

  ngOnInit(): void {
    this.options = this.sizes.map(size => ({
      value: size,
      label: size + '条/页',
    }))
  }

}
